<template>
  <v-container>

    <div class="py-8">
      <v-sheet outlined>
        <v-sheet color="grey-8" class="py-3">
          <div class="d-flex px-4">
            <div class="d-flex" style="width: 400px; max-width: 70%;">
              <v-text-field
                v-model="search"
                single-line
                hide-details
                outlined
                dense
                clearable
                placeholder="訊息名稱"
                @click:clear="clearSearch"
                @keydown.enter="fetchList"
              />
              <v-btn icon color="primary" @click="fetchList">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </div>
            <v-spacer/>
            <v-btn :icon="$vuetify.breakpoint.xsOnly" color="tiffany-9" dark elevation="0" large @click="$router.push({ name: 'CareTemplateNew' })">
              <v-icon>mdi-plus</v-icon>
              <template v-if="$vuetify.breakpoint.smAndUp">建立</template>
            </v-btn>
          </div>
        </v-sheet>

        <div>
          <v-data-table
            height="calc(100vh - 340px)"
            fixed-header
            :headers="headers"
            :items="dataset"
            :loading="loading"
            :options.sync="options"
            :server-items-length="totalItems"
            :footer-props="{ 'items-per-page-options': [10, 20, 50] }"
          >
            <template v-slot:item.message_templates="{ item }">
              <div v-html="formatMessageContent(item)"></div>
            </template>
            <template v-slot:item.frequency="{ item }">
               <div v-html="formatMessageFrequency(item)"></div>
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn icon color="tiffany-9" dark @click="$router.push({ name: 'CareTemplateEdit', params: { id: item.id } })">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </div>
  </v-container>
</template>

<script>
import { getCustomizeCareTagAPI } from "@/api"; // Assumed API function
import { mapGetters } from "vuex";

export default {
  name: 'PostOperativeCareTemplateList',

  data() {
    return {
      loading: false,
      dataset: [],
      search: '',
      options: {},
      totalItems: 0,
    }
  },

  computed: {
    ...mapGetters(['axiosParamData']),
    headers() {
      return [
        { text: '訊息名稱', value: 'tag_name', sortable: false, width: 120 },
        { text: '訊息細項', value: 'message_templates', sortable: false, width: 200 },
        { text: '發送時間', value: 'frequency', sortable: false, width: 200 },
        { text: '編輯', value: 'action', sortable: false, width: 80 },
      ]
    }
  },

  watch: {
    options: {
      handler() {
        this.fetchList();
      },
      deep: true,
    },
  },

  methods: {
    formatMessageContent(item) {
      if (!item.message_templates || item.message_templates.length === 0) return '-';
      return item.message_templates.map((template, index) => {
        return (
          template.title != null && template.title !== ''
        ) ? `${item.tag_name} - ${template.title}` : `${item.tag_name} - ${index + 1}`;
      }).join('<br>');
    },
    formatMessageFrequency(item) {
      if (!item.message_templates || item.message_templates.length === 0) return '-';
      return item.message_templates.map(template => {
        return `
          看診
          ${template.offset_direction === 'AFTER' ? '後' : '前'}
          ${template.start_offset_days}天 ${template.send_at_time}
        `;
      }).join('<br>');
    },
    fetchList() {
      this.loading = true;
      const { page, itemsPerPage } = this.options;
      const params = {
        ...this.axiosParamData,
        page: page,
        limit: itemsPerPage,
        keyword: this.search,
      };

      getCustomizeCareTagAPI(params).then(res => {
        this.dataset = res.data.data;
        this.totalItems = res.data.meta.total;
      }).finally(() => {
        this.loading = false;
      })
    },
    clearSearch() {
      this.search = null;
      this.fetchList();
    },
  }
};
</script>
